import { AfterViewInit, booleanAttribute, Component, computed, ElementRef, inject, input, numberAttribute } from '@angular/core';
import { checkForAccessibleName } from '../utility';


@Component({
  selector: 'mui-progress-bar',
  templateUrl: './mui-progress-bar.component.html',
  host: {
    /* eslint-disable  @typescript-eslint/naming-convention */
    role: 'progressbar',
    class: 'mui-progress-bar',
    '[class.mui-progress-bar--dense]': 'dense()',
    '[attr.aria-label]': 'titleFill()',
    '[attr.aria-valuenow]': 'clampedValue()',
    '[attr.aria-valuemin]': 'min()',
    '[attr.aria-valuemax]': 'max()'
    /* eslint-enable  @typescript-eslint/naming-convention */
  }
})
export class MuiProgressBar implements AfterViewInit {

  readonly animated = input(false, { transform: booleanAttribute });
  readonly dense = input(false, { transform: booleanAttribute });
  readonly indeterminate = input(false, { transform: booleanAttribute });
  readonly titleBackground = input<string | null>(null);
  readonly titleFill = input<string | null>(null);
  readonly value = input<number, unknown>(0, { transform: (v) => numberAttribute(v, 0) });
  readonly min = input<number, unknown>(0, { transform: (v) => numberAttribute(v, 0) });
  readonly max = input<number, unknown>(1, { transform: (v) => numberAttribute(v, 1) });

  protected readonly clampedValue = computed(() => {
    return Math.min(this.max(), Math.max(this.min(), this.value()));
  });

  protected readonly scaleX = computed(() => {
    const range = this.max() - this.min();
    return (this.value() - this.min()) / range;
  });

  protected el: ElementRef<HTMLElement> = inject(ElementRef);

  ngAfterViewInit(): void {
    checkForAccessibleName(this.el.nativeElement, 'MuiProgressBar');
  }
}
